import React from "react";
import { Paper, Typography, Button, Box } from "@mui/material";

const TriviaModeCard = ({ title, subtitle, cta, onClick }) => (
  <Paper
    sx={{
      p: 2.5,
      flex: 1,
      minWidth: 220,
      borderRadius: 2,
      border: "1px solid",
      borderColor: "divider",
      display: "flex",
      flexDirection: "column",
      gap: 1.5,
    }}
  >
    <Box>
      <Typography variant="h6" fontWeight={700}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {subtitle}
      </Typography>
    </Box>
    <Button variant="outlined" onClick={onClick} sx={{ alignSelf: "flex-start" }}>
      {cta}
    </Button>
  </Paper>
);

export default TriviaModeCard;
